const extractPermissions = (seccion) => {
  const permisos = {};

  const traverse = (key, items) => {
    permisos[key] = permisos[key] || [];
    items.forEach((item) => {
      if (item.FCPERMISOS) {
        permisos[key].push(...item.FCPERMISOS.split(","));
      }
      if (item.CHILD2) {
        traverse("CHILD2", item.CHILD2);
      }
    });
  };

  traverse("CHILD1", seccion.CHILD1);

  // Remove duplicates and clean up arrays
  for (const key in permisos) {
    permisos[key] = [...new Set(permisos[key])];
  }

  return permisos;
};

export default extractPermissions;
